import { render } from "./App.vue?vue&type=template&id=76d9904a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=76d9904a&lang=css"

import exportComponent from "/tmp/build_2d2f4584/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__